/**
 * action types
 */
export const CREATE_CERTIFICATION_PATHWAY_START =
  'CREATE_CERTIFICATION_PATHWAY_START';
export const CREATE_CERTIFICATION_PATHWAY_FAILURE =
  'CREATE_CERTIFICATION_PATHWAY_FAILURE';
export const SET_CERTIFICATION_DATA = 'SET_CERTIFICATION_DATA';
export const SAVE_CERTIFICATE_LINK = 'SAVE_CERTIFICATE_LINK';

export const FETCH_STUDENT_CERTIFICATIONS_START =
  'FETCH_STUDENT_CERTIFICATIONS_START';
export const FETCH_STUDENT_CERTIFICATIONS_SUCCESS =
  'FETCH_STUDENT_CERTIFICATIONS_SUCCESS';
export const FETCH_STUDENT_CERTIFICATIONS_FAILURE =
  'FETCH_STUDENT_CERTIFICATIONS_FAILURE';
